import React from 'react';
import { Card, Alert, Button } from 'antd';
import { useNavigate } from "react-router-dom";

const BadRequest400 = () => {
    const navigate = useNavigate();

    return (
        <Card style={{ maxWidth: 600, margin: "50px auto", textAlign: "center" }}>
            <Alert
                message="400 - Bad Request"
                description="The request was invalid or cannot be processed."
                type="error"
                showIcon
            />
            <Button type="primary" style={{ marginTop: 20 }} onClick={() => navigate("/")}>
                Back to Home
            </Button>
        </Card>
    );
};

export default BadRequest400;
